"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductRelatedBlock = void 0;
const utils_1 = require("../../utils/utils");
const base_component_1 = require("../../components/base-component");
const dom_1 = require("../../utils/dom");
const recoLoaded = new CustomEvent('lbc-reco-loaded', {
    cancelable: true,
    bubbles: false
});
class ProductRelatedBlock extends base_component_1.BaseComponent {
    mountComponent() {
        this.loadProducts();
    }
    loadProducts() {
        this.setAttribute('is-loading', '');
        return fetch(this.dataset.url)
            .then(response => response.text())
            .then(text => {
            this.updateByHTML((0, dom_1.parseHTML)(text));
            this.removeAttribute('is-loading');
            window.dispatchEvent(recoLoaded);
        })
            .catch(() => {
            console.log('Error in product recommendations component');
        });
    }
    updateByHTML(html) {
        const recommendations = (0, utils_1.$el)(`#${this.id}`, html);
        (0, dom_1.replaceNodeChildren)(this, recommendations);
        this.toggleAttribute('is-ready', this.hasChildNodes());
    }
}
exports.ProductRelatedBlock = ProductRelatedBlock;
